import { apiClient } from "../../../../../api/client";
import { ApiResponse } from "../../../../../types";
import {
  ConfirmCheckoutParams,
  DocStartParams,
  ImileCheckoutListParams,
  ImileCheckoutRow,
  SubmitRemessaParams,
} from "../types";

/**
 * Mesmos quatro endpoints do entrego; o que muda é o `opsMae`/`ops` no corpo.
 *
 * ConfirmCheckoutParams NÃO tem offerAction de propósito: o split
 * registro/envio é piloto exclusivo do entrego (gestorConfirmCheckout só trata
 * offerAction === "pilotoEnvio" quando ops === "entrego"). A iMile tem um botão só.
 */
export const imileCheckoutService = {
  async getCheckoutList(
    params: ImileCheckoutListParams
  ): Promise<ApiResponse<ImileCheckoutRow[]>> {
    return apiClient.post("/gestorCheckoutList", params);
  },

  async confirmCheckout(
    params: ConfirmCheckoutParams
  ): Promise<ApiResponse<void>> {
    return apiClient.post("/gestorConfirmCheckout", params);
  },

  async startDoc(params: DocStartParams): Promise<ApiResponse<void>> {
    return apiClient.post("/gestorDocStart", params);
  },

  async submitRemessa(
    params: SubmitRemessaParams
  ): Promise<ApiResponse<void>> {
    return apiClient.post("/gestorSubmitRemessaDb", params);
  },
};
